import { Input, Typography } from "antd";
import closeBtn from "../../../assets/icons/closeSm.png";
const { Text } = Typography;

const LPNField = ({
  lpnValue,
  setLpnValue,
  lpnHasSpecicalChar,
  setLpnHasSpecialChar
}) => {
  const handleChange = (input) => {
    const hasSpecial = /[^a-zA-Z0-9 ]/.test(input);
    setLpnHasSpecialChar(hasSpecial);
    !hasSpecial && setLpnValue(input);
  };

  return (
    <div>
      <label className="field-label">LPN</label>
      <Input
        value={lpnValue}
        onChange={(e) => {
          handleChange(e.target.value);
        }}
        suffix={
          <img
            src={closeBtn}
            style={{ visibility: lpnValue ? "visible" : "hidden" }}
            height={10}
            alt="x"
            onClick={() => setLpnValue(null)}
          />
        }
        placeholder="Enter LPN"
      />
      {lpnHasSpecicalChar && (
        <div style={{ marginTop: 2 }}>
          <Text type="danger">Special characters are not allowed</Text>
        </div>
      )}
    </div>
  );
};

export default LPNField;
